import React, { Component } from 'react';
import ReduxToastr from 'react-redux-toastr';

export default class Message extends Component {
	render() {
		return (
			<ReduxToastr 
				timeOut={4000}
				newestOnTop={true}
				preventDuplicates={true}
				position='top-right'
				transitionOut='fadeOut'
				progressBar
			/>
		);
	}
}